import React from "react";

const STATUS_STYLES = {
  application_received: { cls: "pill-info", label: "Application Received" },
  interview_scheduled: { cls: "pill-warning", label: "Interview Scheduled" },
  interview_complete: { cls: "pill-primary", label: "Interview Complete" },
  offer_extended: { cls: "pill-primary", label: "Offer Extended" },
  offer_accepted: { cls: "pill-success", label: "Offer Accepted" },
  onboarding: { cls: "pill-success", label: "Onboarding" },
  employee: { cls: "pill-success", label: "Employee" },
  not_selected: { cls: "pill-danger", label: "Not Selected" },
};

export const STATUSES = [
  "application_received",
  "interview_scheduled",
  "interview_complete",
  "offer_extended",
  "offer_accepted",
  "onboarding",
  "employee",
  "not_selected",
];

export const STATUS_LABEL = Object.fromEntries(
  Object.entries(STATUS_STYLES).map(([k, v]) => [k, v.label])
);

export default function StatusPill({ status }) {
  const s = STATUS_STYLES[status] || { cls: "pill-neutral", label: status };
  return (
    <span className={s.cls} data-testid={`status-pill-${status}`}>
      {s.label}
    </span>
  );
}
